<template>
    <div>
        <div class="page">
            <div class="topdivnew">
                <el-button @click="addClick" type="primary" icon="el-icon-plus" size="small" circle></el-button>
            </div>
            <el-table :data="dataList" style="width: 100%;min-height: 600px;">
                <el-table-column show-overflow-tooltip prop="title" label="标题">
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="remark" label="内容">
                </el-table-column>
                <el-table-column show-overflow-tooltip prop="url" label="url地址">
                    <template slot-scope="scope">
                        <a target="_blank" :href="scope.row.url">{{scope.row.url}}</a>
                    </template>
                </el-table-column>
                <el-table-column show-overflow-tooltip align="center"  width="100" prop="isTop" label="是否置顶">
                    <template slot-scope="scope">
                        <div style="color: red;font-weight: bold;" v-if="scope.row.isTop=='1'">置顶</div>
                        <div style="color: rgb(99, 149, 240);font-weight: bold;" v-else>未置顶</div>
                      </template>
                </el-table-column>
                <el-table-column width="170" align="center" prop="createTime" label="创建时间">
                    <template slot-scope="scope">{{dayjs(scope.row.createTime).format('YYYY-MM-DD HH:mm:ss')}}</template>
                  </el-table-column>
                <el-table-column align="center" width="100" label="操作">
                    <template slot-scope="scope">
                        <el-button @click="editClick(scope.$index, scope.row)" size="small" type="primary"
                            icon="el-icon-edit" circle></el-button>
                        <el-button @click="deleteClick(scope.$index, scope.row)" size="small" type="danger"
                            icon="el-icon-delete" circle></el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="paginationdiv">
                <el-pagination class="pagefy" :total="total" :current-page="pageNumber" :page-size="pageSize"
                    :page-sizes="[10, 20, 30, 50]" @current-change="handleCurrentChange" @size-change="handleSizeChange"
                    background layout="total, sizes, prev, pager, next"></el-pagination>
            </div>
        </div>
        <el-dialog :visible.sync="dialogVisible" width="40%">
            <div class="dialogdivText">
                <div class="rowdiv">
                    <div>资讯标题:</div>
                    <el-input autosize type="textarea" style="width: 85%;margin-left: 15px;" v-model="title"
                        placeholder="请输入标题">
                    </el-input>
                </div>

                <div class="rowdiv">
                    <div>资讯内容:</div>
                    <el-input autosize type="textarea" style="width: 85%;margin-left: 15px;" v-model="content"
                        placeholder="请输入内容">
                    </el-input>
                </div>

                <div class="rowdiv">
                    <div>资讯链接:</div>
                    <el-input autosize type="textarea" style="width: 85%;margin-left: 15px;" v-model="url"
                        placeholder="请输入链接地址">
                    </el-input>
                </div>

                <div class="rowdiv">
                    <div>是否置顶:</div>
                    <el-switch style="margin-left: 30px;" v-model="topping" active-color="#13ce66"
                        inactive-color="#e6e6e6">
                    </el-switch>
                </div>

            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">取 消</el-button>
                <el-button :loading="querenloading" type="primary" @click="querenClick">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import axios from "axios";
    export default {
        data() {
            return {
                querenloading:false,
                dialogVisible: false,
                title: '',//标题
                content: '',//内容
                url: '',//链接地址
                topping: false,//是否置顶
                total: 0,
                dataList: [],
                pageNumber: 1,
                pageSize: 10,
                isaddoredit:'add',
                editId:'',
            }
        },
        //初始化方法
        mounted() {
            this.getdataList();
        },
        methods: {
            //获取列表数据
            getdataList() {
                axios.get(this.baseUrl.hbjx + '/activities/loadPageByPramas', {  //params参数必写 , 如果没有参数传{}也可以
                    params: {
                        pageNum: this.pageNumber,
                        pageSize: this.pageSize,
                    }
                })
                    .then((res) => {
                        this.total = res.data.total;
                        this.dataList = res.data.list;
                    })
                    .catch(function (err) {
                        console.log(err);
                    });
            },
            //稿件编辑
            editClick(index, row) {
                this.isaddoredit = 'edit';
                this.dialogVisible = true;
                this.editId = row.id;
                this.title = row.title;
                this.content = row.remark;
                this.url = row.url;
                this.topping = row.isTop=='1'?true:false;
            },
            saveAddData() {
                this.querenloading = true;
                let params = new FormData(); // 创建form对象
                params.append("title", this.title); // 标题
                params.append("remark", this.content); // 内容
                params.append("url", this.url); // 链接地址
                params.append("isTop", this.topping?'1':'2'); // 是否置顶
                axios.post(this.baseUrl.hbjx + "/activities/saveTSelective", params).then((res) => {
                    if (res.data == 'success') {
                        this.getdataList();
                        this.dialogVisible = false;
                        this.querenloading = false;
                        this.$Message.success('添加成功！');
                    }else{
                        this.querenloading = false;
                        this.dialogVisible = false;
                        this.$Message.error('添加失败！');
                    }
                });
            },
            saveEditData() {
                this.querenloading = true;
                let params = new FormData(); // 创建form对象
                params.append("id", this.editId); // id
                params.append("title", this.title); // 标题
                params.append("remark", this.content); // 内容
                params.append("url", this.url); // 链接地址
                params.append("isTop", this.topping ? '1' : '2'); // 是否置顶
                axios.post(this.baseUrl.hbjx + "/activities/updTByPrimaryKey", params).then((res) => {
                    if (res.data == 'success') {
                        this.getdataList();
                        this.dialogVisible = false;
                        this.querenloading = false;
                        this.$Message.success('修改成功！');
                    } else {
                        this.dialogVisible = false;
                        this.querenloading = false;
                        this.$Message.error('修改失败！');
                    }
                });
            },
            querenClick() {
                if (!this.title) {
                    this.$Message.error('标题不能为空！');
                    return;
                }
                if (!this.content) {
                    this.$Message.error('内容不能为空！');
                    return;
                }
                if (!this.url) {
                    this.$Message.error('资讯链接不能为空！');
                    return;
                }
                if (this.isaddoredit=='add') {
                    this.saveAddData();
                }else if(this.isaddoredit=='edit'){
                    this.saveEditData();
                }else{
                    this.$Message.error('操作错误！');
                    return;
                }
                
            },
            //添加资讯
            addClick() {
                this.isaddoredit = 'add';
                this.dialogVisible = true;
                this.editId = "";
                this.title = "";
                this.content = "";
                this.url = "";
                this.topping = false;
            },
            //删除稿件
            deleteClick(index, row) {
                this.$confirm("是否确认删除?", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                    center: 'true'
                })
                    .then(() => {
                        let params = new FormData(); // 创建form对象
                        params.append("id", row.id); //稿件id
                        axios.post(this.baseUrl.hbjx + "/activities/delTByPrimaryKey", params).then((res) => {
                            if (res.data == "success") {
                                this.getdataList();
                                this.$Message.success('删除成功！');
                            }else{
                                this.$Message.success('删除失败！');
                            }
                        });
                    })
                    .catch(() => { });
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.getdataList();
            },
            handleCurrentChange(val) {
                this.pageNumber = val;
                this.getdataList();
            },
        }
    }
</script>
<style scoped>
    .rowdiv {
        width: 90%;
        margin-top: 20px;
        display: flex;
        height: auto;
        align-items: center;
        margin-bottom: 20px;
    }

    .dialogdivText {
        width: 100;
        height: auto;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }

    .topdivnew {
        width: 100%;
        height: 50px;
        border-bottom: 1px dashed rgb(233, 230, 230);
        margin-bottom: 5px;
        display: flex;
        align-items: center;
        justify-content: flex-end;
        padding-right: 15px;
    }

    .paginationdiv {
        display: flex;
        height: 50px;
        align-items: center;
        width: 100%;
        justify-content: flex-start;
        padding-left: 15px;
    }

    .page {
        position: relative;
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 100%;
        height: auto;
        margin: 5px 0px 5px 0px;
        background-color: #fff;
        -moz-box-shadow: 0 2px 10px 1px rgba(0, 0, 0, 0.2);
        -webkit-box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
        box-shadow: 0 2px 10px 1px rgb(0 0 0 / 20%);
    }

    /deep/ .el-input.is-disabled .el-input__inner {
        background-color: #fff;
        color: black;
    }

    /deep/ .el-input__inner {
        border: none;
        border-bottom: 1px solid #e6e6e6;
    }

    /deep/ .el-textarea__inner {
        border: none;
        border-bottom: 1px solid #e6e6e6;
        /* font-weight: bold; */
    }
</style>


// WEBPACK FOOTER //
// src/components/RealTimeInfo.vue